export const ENVIRONMENT_API = {
  LIVE: "https://merchant-api-live-v2.onepay.lk/api/ipg/gateway",
} as const;
